"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEnvironment = exports.DeploymentModel = exports.ProviderRegion = exports.Location = void 0;
var Location;
(function (Location) {
    Location["Frankfurt"] = "DE-FF";
    Location["Ireland"] = "IE";
    Location["Mumbai"] = "IN-MB";
    Location["Oregon"] = "US-OR";
    Location["Singapore"] = "SG";
    Location["Sydney"] = "AU";
    Location["Virginia"] = "US-VA";
    Location["SaoPaulo"] = "BR-SP";
})(Location = exports.Location || (exports.Location = {}));
var ProviderRegion;
(function (ProviderRegion) {
    ProviderRegion["AWSProviderRegionUSEast1"] = "aws-us-east-1";
    ProviderRegion["AWSProviderRegionUSWest2"] = "aws-us-west-2";
    ProviderRegion["AWSProviderRegionEUCentral1"] = "aws-eu-central-1";
    ProviderRegion["AWSProviderRegionEUWest1"] = "aws-eu-west-1";
    ProviderRegion["AWSProviderRegionAPSoutheast1"] = "aws-ap-southeast-1";
    ProviderRegion["AWSProviderRegionAPSoutheast2"] = "aws-ap-southeast-2";
    ProviderRegion["AWSProviderRegionAPSouth1"] = "aws-ap-south-1";
    ProviderRegion["AWSProviderRegionUSEast2"] = "aws-us-east-2";
    ProviderRegion["AWSProviderRegionEUWest2"] = "aws-eu-west-2";
    ProviderRegion["AWSProviderRegionSAEast1"] = "aws-sa-east-1";
    ProviderRegion["AzureProviderRegionEastUS2"] = "azure-eastus2";
    ProviderRegion["AzureProviderRegionWestUS"] = "azure-westus";
    ProviderRegion["AzureProviderRegionWestEurope"] = "azure-westeurope";
    ProviderRegion["AzureProviderRegionEastAsia"] = "azure-eastasia";
    ProviderRegion["AzureProviderRegionSouthEastAsia"] = "azure-southeastasia";
    ProviderRegion["GCPProviderRegionUSCentral1"] = "gcp-us-central1";
    ProviderRegion["GCPProviderRegionUSWest1"] = "gcp-us-west1";
    ProviderRegion["GCPProviderRegionEuropeWest1"] = "gcp-europe-west1";
    ProviderRegion["GCPProviderRegionAsiaSouth1"] = "gcp-asia-south1";
    ProviderRegion["GCPProviderRegionUSEast4"] = "gcp-us-east4";
})(ProviderRegion = exports.ProviderRegion || (exports.ProviderRegion = {}));
var DeploymentModel;
(function (DeploymentModel) {
    DeploymentModel["Global"] = "GLOBAL";
    DeploymentModel["Local"] = "LOCAL";
})(DeploymentModel = exports.DeploymentModel || (exports.DeploymentModel = {}));
var AppEnvironment;
(function (AppEnvironment) {
    AppEnvironment["None"] = "";
    AppEnvironment["Development"] = "development";
    AppEnvironment["Testing"] = "testing";
    AppEnvironment["Staging"] = "staging";
    AppEnvironment["QA"] = "qa";
    AppEnvironment["Production"] = "production";
})(AppEnvironment = exports.AppEnvironment || (exports.AppEnvironment = {}));
//# sourceMappingURL=App.js.map